<template>
  <div class="userInfo">
    <el-form
      class="user-info-form"
      :model="model"
      :rules="rules"
      ref="form"
      @submit.native.prevent="changePassword"
      label-width="120px"
      label-position="left"
    >
      <div v-if="!isChangePassword" class="change-password">
        <i class="warning-change-pass"></i>
        <p class="mes-change-pass">Bạn đang sử dụng mật khẩu hệ thống cung cấp vui lòng đổi mật khẩu</p>
      </div>
      <p>QUẢN LÝ TÀI KHOẢN</p>
      <h5 class="user-name">{{ this.userInfomation.data.name }}</h5>
      <p class="user-info-title">THÔNG TIN CÁ NHÂN</p>
      <el-row>
        <el-col :span="12" class="user-info-form-item">
          <el-form-item label="Họ và tên">
            <el-input v-model="userInfomation.data.name" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" class="user-info-form-item">
          <el-form-item label="Email cá nhân">
            <el-input v-model="userInfomation.data.email" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" class="user-info-form-item">
          <div v-if="userInfomation.data.roles.length !== 0">
            <el-form-item label="Vai trò">
              <el-input v-model="userInfomation.data.roles[0].name" :disabled="true"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" class="user-info-form-item">
          <el-form-item label="Tên đăng nhập">
            <el-input v-model="userInfomation.data.username" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <p class="user-change-password-title">ĐỔI MẬT KHẨU</p>
      <el-row>
        <el-col :span="12" class="user-info-form-item">
          <el-form-item label="Mật khẩu cũ" prop="oldPassword">
            <el-input v-model="model.oldPassword" type="password" rows="2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" class="user-info-form-item">
          <el-form-item label="Mật khẩu mới" prop="newPassword">
            <el-input v-model="model.newPassword" type="password"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item class="btn-user-info">
        <el-button
          :loading="loading"
          class="change-pass-button"
          type="primary"
          native-type="submit"
          block
        >Lưu</el-button>
      </el-form-item>

      <p class="user-change-password-title">QUẢN LÝ API KEY</p>
      <div class="api-key-section">
        <div class="api-key-actions">
          <el-button
            v-if="!apiKeyData"
            :loading="generatingKey"
            type="primary"
            @click="generateKey"
          >Tạo API Key mới</el-button>
          <el-button
            v-else
            :loading="generatingKey"
            type="warning"
            @click="regenerateKey"
          >Tạo lại API Key</el-button>
          <el-button
            type="info"
            icon="el-icon-document"
            @click="downloadDocumentation"
          >Tải tài liệu</el-button>
        </div>

        <div v-if="apiKeyData" class="api-key-info">
          <div class="api-key-row">
            <div class="api-key-label">API Key:</div>
            <div class="api-key-value">
              <el-input v-model="apiKeyData.key" readonly>
                <template slot="append">
                  <el-button @click="copyApiKey">Copy</el-button>
                </template>
              </el-input>
            </div>
          </div>

          <div class="api-key-row">
            <div class="api-key-label">Trạng thái:</div>
            <div class="api-key-value">
              <el-tag :type="apiKeyData.status === 1 ? 'success' : 'danger'">
                {{ apiKeyData.status === 1 ? 'Hoạt động' : 'Không hoạt động' }}
              </el-tag>
            </div>
          </div>

          <div class="api-key-row">
            <div class="api-key-label">IP Whitelist:</div>
            <div class="api-key-value">
              <el-input 
                v-model="ipWhitelist" 
                placeholder="Nhập IP, phân cách bằng dấu phẩy"
                @change="updateIpWhitelist"
              >
                <template slot="prepend">
                  <el-button @click="getCurrentIP" :loading="loadingIP">
                    <i class="el-icon-refresh"></i>
                  </el-button>
                </template>
                <template slot="append">
                  <el-button @click="updateIpWhitelist">Lưu</el-button>
                </template>
              </el-input>
              <div v-if="currentIP" class="ip-suggestion">
                <span>IP hiện tại: {{ currentIP }}</span>
                <el-button type="text" @click="addCurrentIP">Thêm vào whitelist</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import UserRequest from "@/requests/UserRequest";
export default {
  name: "userInfo",
  data() {
    var checkSamePassword = (rule, value, callback) => {
      if (
        this.model.oldPassword &&
        value == this.model.oldPassword &&
        !this.isWrongOldPass
      ) {
        callback(new Error("Mật khẩu mới phải khác mật khẩu cũ."));
      } else {
        callback();
      }
    };
    var checkOldPassword = (rule, value, callback) => {
      const oldPass = {
        oldPassword: value,
      };
      const res = UserRequest.checkCorrectOldPassword(
        this.userInfomation.data.id,
        oldPass
      ).then((res) => {
        if (!res.data) {
          this.isWrongOldPass = true;
          callback(new Error("Mật khẩu cũ không đúng."));
        } else {
          this.isWrongOldPass = false;
          callback();
        }
      });
    };
    var checkOldPasswordNotmes = (rule, value, callback) => {
      const oldPass = {
        oldPassword: this.model.oldPassword,
      };
      const res = UserRequest.checkCorrectOldPassword(
        this.userInfomation.data.id,
        oldPass
      ).then((res) => {
        if (!res.data) {
          callback();
        } else {
          callback();
        }
      });
    };
    return {
      userInfomation: {
        data: {
          name: "",
          email: "",
          username: "",
          roles: [],
        },
      },
      model: {
        oldPassword: "",
        newPassword: "",
      },
      isWrongOldPass: false,
      isCorrectOldPass: true,
      isChangePassword: true,
      loading: false,
      generatingKey: false,
      apiKeyData: null,
      ipWhitelist: "",
      currentIP: "",
      loadingIP: false,
      rules: {
        oldPassword: [
          {
            required: true,
            message: "Vui lòng nhập mật khẩu cũ.",
            trigger: "blur",
          },
          {
            required: true,
            validator: checkOldPassword,
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            message: "Vui lòng nhập mật khẩu mới.",
            trigger: "blur",
          },
          {
            required: true,
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z!@#$%^&*(),.?":{}|<>\d]{8,50}$/,
            message:
              "Mật khẩu mới phải từ 8-50 ký tự, phải có ít nhất 1 chữ cái viết hoa, 1 chữ cái thường và 1 chữ số.",
            trigger: "blur",
          },
          {
            required: true,
            validator: checkOldPasswordNotmes,
            trigger: "blur",
          },
          {
            required: true,
            validator: checkSamePassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created: async function () {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    this.userInfomation = await UserRequest.getUserInfo(userInfo.id);

    UserRequest.isChangePassword({
      username: this.userInfomation.data.username,
    }).then((res) => {
      this.isChangePassword = res.isChange;
    });

    // Load existing API key
    try {
      const response = await UserRequest.getApiKey({
        userId: this.userInfomation.data.id
      });
      if (response.data) {
        this.apiKeyData = response.data;
        this.ipWhitelist = response.data.ip_whitelist || "";
      }
    } catch (error) {
      console.error("Error loading API key:", error);
    }
  },
  methods: {
    async changePassword() {
      let valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }
      try {
        await UserRequest.changePassword(
          this.userInfomation.data.id,
          this.model,
          this.userInfomation.data.email
        );
        this.$message.success("Cập nhật mật khẩu thành công.");
        this.isChangePassword = true;
      } catch (e) {
        this.isCorrectOldPass = false;
      }
    },
    /**
     * Generate new API key
     * Response structure:
     * {
     *   code: 200,
     *   success: true,
     *   data: {
     *     name: string,           // Name of the API key
     *     organization_id: number, // Organization ID
     *     user_id: number,        // User ID
     *     rate_limit: number,     // Number of requests allowed
     *     rate_limit_period: number, // Time period in seconds
     *     ip_whitelist: string|null, // IP whitelist if any
     *     status: number,         // 1 for active, 0 for inactive
     *     key: string,           // The actual API key
     *     updated_at: string,    // Last update timestamp
     *     created_at: string,    // Creation timestamp
     *     id: number            // API key ID
     *   }
     * }
     */
    async generateKey() {
      this.generatingKey = true;
      try {
        const response = await UserRequest.generateApiKey({
          userId: this.userInfomation.data.id
        });
        if (response.success && response.data) {
          this.apiKeyData = response.data;
          this.ipWhitelist = response.data.ip_whitelist || "";
          this.$message.success("Tạo API Key thành công");
        } else {
          throw new Error(response.message || "Không thể tạo API Key");
        }
      } catch (error) {
        this.$message.error(error.message || "Không thể tạo API Key");
      } finally {
        this.generatingKey = false;
      }
    },
    copyApiKey() {
      if (!this.apiKeyData?.key) return;
      navigator.clipboard.writeText(this.apiKeyData.key).then(() => {
        this.$message.success("Đã sao chép API Key");
      }).catch(() => {
        this.$message.error("Không thể sao chép API Key");
      });
    },
    addCurrentIP() {
      if (!this.currentIP) return;
      
      // Split existing IPs and clean them
      const ips = this.ipWhitelist
        .split(',')
        .map(ip => ip.trim())
        .filter(ip => ip !== '');

      // Add current IP if not exists
      if (!ips.includes(this.currentIP)) {
        ips.push(this.currentIP);
      }

      // Join back with comma and space
      this.ipWhitelist = ips.join(', ');
    },
    async updateIpWhitelist() {
      if (!this.apiKeyData?.id) return;
      
      try {
        // Clean and format IPs before sending
        const formattedIPs = this.ipWhitelist
          .split(',')
          .map(ip => ip.trim())
          .filter(ip => ip !== '')
          .join(', ');

        const response = await UserRequest.updateApiKey(this.apiKeyData.id, {
          ip_whitelist: formattedIPs
        });
        
        if (response.success) {
          this.$message.success("Cập nhật IP Whitelist thành công");
          this.apiKeyData.ip_whitelist = formattedIPs;
          this.ipWhitelist = formattedIPs; // Update local state with formatted value
        } else {
          throw new Error(response.message || "Không thể cập nhật IP Whitelist");
        }
      } catch (error) {
        this.$message.error(error.message || "Không thể cập nhật IP Whitelist");
      }
    },
    async getCurrentIP() {
      this.loadingIP = true;
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        this.currentIP = data.ip;
      } catch (error) {
        this.$message.error("Không thể lấy IP hiện tại");
      } finally {
        this.loadingIP = false;
      }
    },
    async regenerateKey() {
      if (!this.apiKeyData?.id) return;
      
      this.generatingKey = true;
      try {
        const response = await UserRequest.regenerateApiKey(this.apiKeyData.id);
        if (response.success && response.data) {
          this.apiKeyData = response.data;
          this.ipWhitelist = response.data.ip_whitelist || "";
          this.$message.success("Tạo lại API Key thành công");
        } else {
          throw new Error(response.message || "Không thể tạo lại API Key");
        }
      } catch (error) {
        this.$message.error(error.message || "Không thể tạo lại API Key");
      } finally {
        this.generatingKey = false;
      }
    },
    downloadDocumentation() {
      const docUrl = process.env.VUE_APP_APIKEY_DOCUMENT;
      if (!docUrl) {
        this.$message.error("Không tìm thấy đường dẫn tài liệu");
        return;
      }
      
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = docUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      
      // Append to body, click and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss">
.user-name{
  word-break: break-word;
}
.btn-user-info {
  margin-top: 30px;
  .el-form-item__content {
    margin-left: 0px !important;
  }
}
.user-info-form-item {
  .el-form-item {
    .el-form-item__label {
      color: #2c2c2c;
      font-family: Helvetica;
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.warning-change-pass {
  padding-right: 10px;
  &:before {
    content: url("../../assets/images/icons/warning-change-pass.svg");
  }
}
.change-password {
  display: inline-flex;
  margin-bottom: 20px;
}
.mes-change-pass {
  font-family: Helvetica;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height */

  color: #f56c6c;
}
.userInfo {
  margin-top: 30px;
  .user-info-form {
    padding: 35px 21px;
  }
}
.user-info-form-item {
  .el-form-item {
    margin-bottom: 30px;
    .el-form-item__label {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #2c2c2c;
      font-family: Helvetica;
    }
  }
}
p {
  font-family: Helvetica;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #909399;
  margin: 0px;
}
h5 {
  font-family: Helvetica;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  color: #363740;
  justify-content: left;
  margin: 31px 0px 43px;
}
.user-info-title,
.user-change-password-title {
  margin-bottom: 24px;
}
label {
  font-family: Helvetica;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #2c2c2c;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.change-pass-button {
  background: #409eff;
  border-radius: 4px;
  border-color: #409eff;
  width: 95px;
  height: 40px;
}
.el-tag {
  margin-right: 10px;
}
.ip-suggestion {
  margin-top: 5px;
  font-size: 12px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 10px;
}
.el-button + .el-button {
  margin-left: 10px;
}
.api-key-section {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;

  .api-key-actions {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
  }

  .api-key-info {
    .api-key-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .api-key-label {
      width: 120px;
      padding-top: 8px;
      color: #606266;
      font-weight: 500;
    }

    .api-key-value {
      flex: 1;
      max-width: 600px;
    }
  }
}

.ip-suggestion {
  margin-top: 5px;
  font-size: 12px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 10px;
}

.el-button + .el-button {
  margin-left: 0;
}
</style>
<style lang="scss">
.passwordOld {
  .el-input__inner {
    width: 470px;
  }
}
</style>
